import getInitialState from './reconfiguration.state';
import mutations from './reconfiguration.mutations';
import actions from './reconfiguration.actions';
import getters from './reconfiguration.getters';

export default {
  namespaced: true,
  state: getInitialState(),
  getters,
  mutations,
  actions
};
